<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h3>Accounts</h3>
      </div>
      <div class="grid-body">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Account name</th>
              <th>Account Number</th>
              <th>Bank Name</th>
              <th>Current Balance</th>
              <th class="text-right">
                <button class="btn btn-xs btn-success" @click="showModalBox">
                  <i class="fa fa-plus-circle" aria-hidden="true"></i>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(account, index) in accounts" :key="account.id">
              <td>
                <router-link
                  :to="{
                    path: '/accounting/accounts/transactions/' + account.id,
                  }"
                >
                  {{ account.account_name }}
                </router-link>
              </td>
              <td>{{ account.account_number }}</td>
              <td>{{ account.bank_name }}</td>
              <td class="text-right">
                {{ ezy.comma(account.current_balance) }}
              </td>
              <td class="text-right">
                <button class="btn btn-primary" @click="editAccount(index)">
                  <i class="fa fa-edit" aria-hidden="true"></i>
                </button>
                <button
                  v-if="account.trans == 0"
                  class="btn btn-danger"
                  @click="delAccount(index)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-if="selectedIndex == null">
              New Account
            </h5>
            <h5 class="modal-title" v-else>Update Account</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12" v-if="Object.keys(error).length > 0">
                  <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading">Some Fields are Required!</h4>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      >Account Name *
                      <small
                        v-if="error.account_name"
                        class="form-text text-danger"
                        >Required</small
                      >
                    </label>
                    <input
                      type="text"
                      v-model="account.account_name"
                      class="form-control"
                      placeholder="Enter Account Name"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>Account Number </label>
                    <input
                      type="text"
                      v-model="account.account_number"
                      class="form-control"
                      placeholder="Enter Account Number"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>Bank Name </label>
                    <input
                      type="text"
                      v-model="account.bank_name"
                      class="form-control"
                      placeholder="Enter Bank Name"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      >Opening Balance *
                      <small
                        v-if="error.opening_balance"
                        class="form-text text-danger"
                        >Required</small
                      >
                    </label>
                    <input
                      type="number"
                      :disabled="account.trans != 0"
                      v-model="account.opening_balance"
                      class="form-control"
                      placeholder="Enter Opening Balance"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  Enabled <toggle-button v-model="account.active" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              v-if="selectedIndex == null"
              @click="openAccount()"
              type="button"
              class="btn btn-primary"
            >
              Save
            </button>
            <button
              v-else
              @click="updateAccount()"
              type="button"
              class="btn btn-primary"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import account from "./Classes/account";
import ezy from "./Tools/ezyFunction";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      account: { active: true },
      error: {},
      accounts: [],
      ezy,
      selectedIndex: null,
    };
  },
  mounted() {
    this.getAccount();
  },
  methods: {
    showModalBox() {
      this.selectedIndex = null;
      this.account = { active: true, trans: 0 };
      show_modal("#modal-box");
    },

    async getAccount() {
      let res = await account.get();
      this.accounts = res;
    },

    editAccount(index) {
      this.selectedIndex = index;
      let account = this.accounts[index];
      account["active"] = account.active ? true : false;
      this.account = account;
      show_modal("#modal-box");
    },

    async updateAccount() {
      this.error = {};
      if (!this.account.account_name) {
        this.error["account_name"] = true;
        return false;
      }
      if (!this.account.opening_balance) {
        this.error["opening_balance"] = true;
        return false;
      }

      let res = await account.edit(this.account);
      if (res) {
        this.account = { active: true };
        hide_modal("#modal-box");
        toastr.success("Successfylly Updated");
        this.getAccount();
      }
    },

    async delAccount(index) {
      const { value: value } = await Swal.fire({
        type: "warning",
        title: "Are You Sure",
        confirmButtonText: "YES",
        showCancelButton: true,
      });
      if (value) {
        let id = this.accounts[index].id;
        let res = await account.destroy(id);
        if (res) {
          toastr.success("Successfylly Deleted");
          this.accounts.splice(index, 1);
        }
      }
    },

    async openAccount() {
      this.error = {};
      if (!this.account.account_name) {
        this.error["account_name"] = true;
        return false;
      }
      if (!this.account.opening_balance) {
        this.error["opening_balance"] = true;
        return false;
      }

      let res = await account.create(this.account);
      if (res) {
        hide_modal("#modal-box");
        toastr.success("Successfylly Created");
        this.getAccount();
      }
    },
  },
};
</script>
<style scoped>
.modal-header .close {
  margin-top: -20px !important;
}
</style>
